class GlobalIdMismatchedTypeError extends Error {
    providedId;
    constructor(providedId, expectedTypes, providedType) {
        const expected = expectedTypes
            .map((type) => {
            return `"${type}"`;
        })
            .join(' or ');
        super(`Mismatched type in provided global ID. Expected ${expected} but received "${providedType}".`);
        this.providedId = providedId;
    }
}
class MalformedGlobalIdError extends Error {
    providedId;
    constructor(providedId) {
        super('Malformed global ID provided');
        this.providedId = providedId;
    }
}
export const fromGlobalId = (globalId, typeName, constraint = 'number') => {
    if (!globalId) {
        throw new Error('Provided empty global ID');
    }
    let payload;
    try {
        // Check if Buffer is available (Node.js environment)
        if (typeof Buffer !== 'undefined') {
            payload = JSON.parse(Buffer.from(globalId, 'base64').toString());
        }
        // If in a browser environment
        else if (typeof window !== 'undefined' &&
            typeof window.atob === 'function') {
            payload = JSON.parse(atob(globalId));
        }
        else {
            throw new TypeError('No suitable environment found for Base64 decoding');
        }
    }
    catch {
        throw new MalformedGlobalIdError(globalId);
    }
    try {
        if (Array.isArray(payload) && payload.length === 2) {
            if (typeName !== undefined) {
                const expectedTypes = typeof typeName === 'string' ? [typeName] : typeName;
                if (!expectedTypes.includes(payload[0])) {
                    throw new GlobalIdMismatchedTypeError(globalId, expectedTypes, payload[0]);
                }
            }
            const id = constraint === 'string' ? String(payload[1]) : payload[1];
            return {
                id,
                typeName: payload[0],
            };
        }
    }
    catch (error) {
        throw new Error(error);
    }
    throw new Error('Unexpected error');
};
//# sourceMappingURL=fromGlobalId.js.map